/** React 19 hoists <title> into <head>, so each page can name the browser tab. */
export function DocumentTitle({ title }: { title: string }) {
  return <title>{`${title} · Milqit Admin`}</title>;
}
